import useHeic from 'src/core/CoreFilePicker/composables/useHeic'

const { checkHeicNoSafari } = useHeic()

describe('useHeic', () => {
  describe('checkHeicNoSafari', () => {
    test('Тогда в safari браузере возвращает false', () => {
      Object.defineProperty(window.navigator, 'userAgent', {
        value: 'Mozilla/5.0 (iPhone; CPU iPhone OS 14_6 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/14.1.1 Mobile/15E148 Safari/604.1',
        configurable: true,
      })

      const file = new File(['content'], 'test.HEIC', { type: 'image/heic' })
      const result = checkHeicNoSafari(file)

      expect(result).toBe(false)
    })

    describe('Не в safari браузере', () => {
      beforeEach(() => {
        // Сброс User Agent
        Object.defineProperty(window.navigator, 'userAgent', {
          value: 'Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/146.0.0.0 Safari/537.36',
          configurable: true,
        })
      })

      test('Тогда для .heic файла на десктопе возвращает true', () => {
        const file = new File(['content'], 'test.HEIC', { type: 'image/heic' })
        const result = checkHeicNoSafari(file)

        expect(result).toBe(true)
      })

      test('Тогда для обычного файла на десктопе возвращает false', () => {
        const file = new File(['content'], 'test.jpg', { type: 'image/jpeg' })
        const result = checkHeicNoSafari(file)

        expect(result).toBe(false)
      })

      test('Тогда для .heic файла с любым кейсом имени возвращает false', () => {
        const file = new File(['content'], 'test.HeiC', { type: 'image/heic' })
        const result = checkHeicNoSafari(file)

        expect(result).toBe(true)
      })

      test('Тогда для файла без расширения heic возвращает false', () => {
        const file = new File(['content'], 'test.heif', { type: 'image/heif' })
        const result = checkHeicNoSafari(file)

        expect(result).toBe(false)
      })
    })
  })
})
